import { render, staticRenderFns } from "./pickupBlockComponent.vue?vue&type=template&id=6f2df69e&"
import script from "./pickupBlockComponent.vue?vue&type=script&lang=js&"
export * from "./pickupBlockComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports